export default "__VITE_ASSET__9e04b8b0__"